import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatCHF, formatDateTime } from "../lib/api";
import { useT } from "../i18n/I18nContext";
import { Gavel } from "lucide-react";

export default function AuctionsListPage() {
  const t = useT();
  const [auctions, setAuctions] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/auctions");
      setAuctions(data);
    })();
  }, []);
  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-8">
      <div className="mb-6 flex items-center gap-3">
        <Gavel className="w-6 h-6 text-[#0F4C3A]" />
        <h1 className="font-heading text-3xl font-medium text-[#0F4C3A]" data-testid="auctions-list-title">{t("auction.list_title")}</h1>
      </div>
      <div className="nv-border bg-white rounded-md divide-y divide-[#E2E8E4]">
        {auctions.length === 0 && <div className="p-10 text-center text-[#94A3B8]">{t("auction.no_auctions")}</div>}
        {auctions.map((a) => (
          <Link key={a.id} to={`/auctions/${a.id}`} className="px-5 py-4 flex items-center justify-between hover:bg-[#F8FAF9]" data-testid={`auction-list-${a.id}`}>
            <div>
              <div className="font-medium text-[#0F4C3A]">{t("auction.month")} {a.month}</div>
              <div className="text-xs text-[#475569] mt-1">
                {t("auction.status")}: {a.status}{a.opened_at && ` · ${t("auction.opened")} ${formatDateTime(a.opened_at)}`}
                {a.winning_bid !== null && a.winning_bid !== undefined && ` · ${t("group.winning_bid")} CHF ${formatCHF(a.winning_bid)}`}
              </div>
            </div>
            <div className={`text-xs uppercase tracking-wider font-semibold ${a.status === "open" ? "text-[#D4AF37] animate-pulse" : "text-[#94A3B8]"}`}>
              {a.status}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
